import { Component, OnInit } from "@angular/core";
import { AudioPlayerComponent } from "ngx-audio-player";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { BaseService } from "../base.service";
import { ToastrService } from "ngx-toastr";
import { environment } from "src/environments/environment";
import { NgxSpinnerService } from "ngx-spinner";
import { MatDialog } from "@angular/material/dialog";
import { AddToPlaylistComponent } from "../add-to-playlist/add-to-playlist.component";
import { ShareMusicContentComponent } from "../share-music-content/share-music-content.component";
import * as CryptoJS from "crypto-js";
import { ThrowStmt } from "@angular/compiler";

@Component({
  selector: "app-song-detail",
  templateUrl: "./song-detail.component.html",
  styleUrls: ["./song-detail.component.css"],
  providers: [AudioPlayerComponent],
})
export class SongDetailComponent implements OnInit {
  status = true;
  isLogin: boolean;
  isActive = false;
  appConstant: any;
  button: any;
  thumbnails: any;
  output_url: any;
  playerStatus = true;
  public_id: any;
  songlist: any = [];
  encodeUrl: any;
  type: any;
  model: any = {};
  params = {
    limit: 10,
    offset: 0,
  };
  songData: any = [];
  typeContent: any;
  shimmerStatus = {
    topSongs: false,
  };
  songContent: any;
  constructor(
    public audiocomponent: AudioPlayerComponent,
    private route: ActivatedRoute,
    public service: BaseService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    public dialog: MatDialog,
    private router: Router
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  ngOnInit(): void {
    this.public_id = this.route.snapshot.paramMap.get("id");
    this.songDetail();
    this.getTopSongs();
    if (localStorage.getItem(environment.localStorageKey)) {
      this.isLogin = true;
    }
    this.encodeUrl = CryptoJS.AES.encrypt(
      JSON.stringify(this.router.url),
      environment.secretkey
    ).toString();
    this.appConstant = environment;
    this.route.queryParamMap.subscribe((params: any) => {});
  }

  songDetail() {
    this.service.videoDetailService(this.public_id).subscribe((res) => {
      this.songContent = res.results;
      this.contentType();
      this.loginCheck();
    });
  }

  getTopSongs() {
    this.service.topSongsList(this.params).subscribe(
      (res) => {
        this.songData = res.results;
        this.shimmerStatus.topSongs = false;
      },
      (err: any) => {
        this.shimmerStatus.topSongs = false;
      }
    );
  }
  singIn(event) {
    this.router.navigate(["/login"], {
      queryParams: {
        public_id: this.encodeUrl,
        event: event,
      },
    });
  }
  addToPlayList(data: any) {
    const dialogRef = this.dialog.open(AddToPlaylistComponent, {
      panelClass: "song-dialog",
      data: data,
      closeOnNavigation: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.isActive = !this.isActive;
    });
  }

  openShareContent() {
    const dialogRef = this.dialog.open(ShareMusicContentComponent, {
      panelClass: "song-dialog",
      data: this.songContent,
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.isActive = !this.isActive;
    });
  }
  classActive() {
    this.isActive = !this.isActive;
  }
  loginCheck() {
    if (history.state.event === "Add_to_playlist") {
      this.isActive = true;
      this.addToPlayList(this.songContent);
    } else if (history.state.event === "Add_to_favorite") {
      if (!this.songContent.is_favorite.id) {
        this.favoriteSong(this.songContent);
      }
    } else if (history.state.event === "Add_to_favorites") {
      this.isActive = true;
      if (!this.songContent.is_favorite.id) {
        this.favoriteSong(this.songContent);
      }
    }
  }

  favoriteSong(event) {
    const id = {
      favorite_id: event.public_id,
      type:
        this.songContent.type == "music"
          ? "album"
          : this.model.type == "podcast"
          ? "podcast"
          : "",
    };
    if (event.is_favorite) {
      if (!event.is_favorite.id) {
        this.service.addFavorite(id).subscribe(
          (detail) => {
            this.songContent.is_favorite.id = detail.id;
            this.songContent.is_favorite.is_favorite = "yes";
            this.toastr.success("Added to Favorite", "Success!", {
              positionClass: "toast-bottom-left",
              closeButton: true,
            });
          },
          (err) => {
            this.toastr.error(err.error.message, "OOPS!", {
              closeButton: true,
            });
          }
        );
      } else {
        this.service.removeFavorite(event.is_favorite.id).subscribe(
          (detail) => {
            this.songContent.is_favorite.id = "";
            this.songContent.is_favorite.is_favorite = "no";
            this.toastr.success("Removed from Favorite", "Success!", {
              positionClass: "toast-bottom-left",
              closeButton: true,
            });
          },
          (err) => {
            this.toastr.error(err.error.message, "OOPS!", {
              closeButton: true,
            });
          }
        );
      }
    }
  }
  songPlay(event) {}
  songStatus(event) {
    if (event.status === "complete") {
      this.play();
    }
  }
  play() {
    this.playerStatus = false;
    this.service.audioStatus = !this.service.audioStatus;
    this.output_url = this?.songContent;
    this.playerStatus = true;
  }
  getImage() {
    let src;
    let item = this.songContent?.thumbnails.filter(
      (item) => item.image_type === "square"
    );
    if (item.length === 0) {
      src = environment.squareDefault;
      return src;
    } else {
      return item[0]?.asset;
    }
  }
  contentType() {
    this.typeContent = this?.songContent.output_url.split(".").pop();
    if (this.typeContent == "mp3") {
      this.typeContent = "audio/mp3";
    } else if (this.typeContent == "mp4") {
      this.typeContent = "video/mp4";
    } else {
      this.typeContent = "application/x-mpegURL";
    }
  }

  ngOnDestroy() {
    this.dialog.closeAll();
  }
}
